import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { trackPageView } from './analytics';

export const RouteObserver = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view whenever location changes
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null; // This component doesn't render anything
};
